/* Klevu popstate guard/retry — added by Claude for the issue:
   "Filter And Back Navigation Restore Fails On Category/Landing Pages (Klevu)"
   Overrides window.onpopstate (originally defined in
   klevu-theme-moss_essence.js, loaded just before this file) with a version
   that retries briefly instead of throwing when window.klevuCurrentScope or
   window.klevuCurrentScope.element isn't set yet. That gap previously
   surfaced as:
     "undefined is not an object (evaluating window.klevuCurrentScope.element)"
   most often on mobile Safari, when a page is restored (e.g. from the
   back-forward cache) before Klevu's own init hook has run. */
window.onpopstate = function (event) {
    var attemptsRemaining = 10; // ~1s total at 100ms intervals
    function attemptRestore() {
        if (!window.klevuCurrentScope || !window.klevuCurrentScope.element) {
            if (attemptsRemaining > 0) {
                attemptsRemaining--;
                setTimeout(attemptRestore, 100);
            } else {
                console.log('[klevu] onpopstate: klevuCurrentScope was never set, skipping filter/history restore');
            }
            return;
        }
        try {
            var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
            var data = window.klevuCurrentScope.element.kObject.getScope().data;
            var scope = window.klevuCurrentScope.element;
            scope.kScope.data = scope.kObject.resetData(scope.kElem);
            scope.kScope.data.context.keyCode = 0;
            scope.kScope.data.context.eventObject = event;
            scope.kScope.data.context.event = "keyUp";
            scope.kScope.data.context.preventDefault = false;
            klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);
            klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
        } catch (error) {
            console.log(error);
        }
    }
    attemptRestore();
};
